import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import "./index.css";
import CausesSection from "../../../components/ServiceComponents/CausesSection";
import Footer from "../../../components/MainComponents/Footer";
import HowToManage from "../../../components/ServiceComponents/HowToManageSection";
import MeetOurExperts from "../../../components/MainComponents/MeetOurExperts";
import AppointmentSection from "../../../components/ServiceComponents/AppointmentSection";
import { getServiceById } from "../../../utils/Data";
import withAnimation from "../../../hooks/withAnimation";
import Header from "../../../components/MainComponents/Header";
import ServiceBanner from "../../../components/ServiceComponents/ServiceBanner";
import ServiceList from "../../../components/MainComponents/ServiceList";
import BookAppointmentSection from "../../../components/HomeComponents/BookAppointmentSection";
import HealingStories from "../../../components/HomeComponents/HealingStories";
import FeatureSection from "../../../components/HomeComponents/FeatureSection";
import InsurancePartners from "../../../components/HomeComponents/InsurancePartners";
import AreasWeServe from "../../../components/MainComponents/AreasWeServe";
import ContactHeader from "../../../components/MainComponents/ContactHeader";

const ServiceDetail = () => {
  const { serviceId } = useParams();
  const [service, setService] = useState({});

  useEffect(() => {
    const serviceData = getServiceById(serviceId);
    setService(serviceData);
  }, [serviceId]);

  if (!service) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <section className="service-detail-header bg-white">
        <ContactHeader/>
        <Header />
        <ServiceBanner image={service.image} title={service.title} description = {service.description}/>
        <ServiceList/>
        <BookAppointmentSection mainImage={service.imageTwo}/>
        {/* <HealingStories/> */}
        <FeatureSection/>
        <CausesSection
          causes={service.causes}
          causeImage={service.imageThree}
          serviceName={service.title}
        />
        <HowToManage
          management={service.management}
          serviceName={service.title}
        />

        <AppointmentSection />

        {/* <MeetOurExperts doctors={service.doctors} /> */}
        {/* <InsurancePartners/> */}
        <AreasWeServe/>
      </section>
      <Footer />
    </div>
  );
};

export default withAnimation(ServiceDetail);
